export function getMapHighlightPaint(role) {
    var paints = {
        fill: {
            'fill-color': 'rgba(250, 204, 21, 0.48)',
            'fill-opacity': 0.75
        },
        polygonCasing: {
            'line-color': '#111827',
            'line-width': 8,
            'line-opacity': 0.92
        },
        polygonLine: {
            'line-color': '#fde047',
            'line-width': 4.5,
            'line-opacity': 0.98
        },
        lineStringCasing: {
            'line-color': '#111827',
            'line-width': 10,
            'line-opacity': 0.95
        },
        lineString: {
            'line-color': '#fde047',
            'line-width': 6,
            'line-opacity': 0.98
        },
        circle: {
            'circle-radius': 9,
            'circle-color': '#fde047',
            'circle-stroke-color': '#111827',
            'circle-stroke-width': 3,
            'circle-opacity': 0.98
        }
    };

    return Object.assign({}, paints[role] || {});
}

export function createMapHighlightPulsator(config) {
    var animationFrame = null;
    var startedAt = 0;
    var layerIds = config.layerIds || {};

    function stop() {
        if (animationFrame != null) {
            cancelAnimationFrame(animationFrame);
            animationFrame = null;
        }
    }

    function start(mode) {
        stop();
        var map = config.getMap();
        if (!map) return;
        var isFamily = mode === 'family';
        if (window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;
        startedAt = performance.now();

        function setPaint(mapInstance, layerId, property, value) {
            if (layerId && mapInstance.getLayer(layerId)) {
                mapInstance.setPaintProperty(layerId, property, value);
            }
        }

        function step(now) {
            var currentMap = config.getMap();
            if (!currentMap) {
                animationFrame = null;
                return;
            }

            var phase = (Math.sin((now - startedAt) / 1000 * Math.PI * 1.4) + 1) / 2;
            var strokeOpacity = (isFamily ? 0.72 : 0.55) + phase * (isFamily ? 0.28 : 0.45);

            setPaint(currentMap, layerIds.fill, 'fill-opacity', (isFamily ? 0.58 : 0.4) + phase * (isFamily ? 0.38 : 0.6));
            setPaint(currentMap, layerIds.polygonCasing, 'line-width', (isFamily ? 8 : 5) + phase * (isFamily ? 5 : 2));
            setPaint(currentMap, layerIds.polygonCasing, 'line-opacity', strokeOpacity);
            setPaint(currentMap, layerIds.polygonLine, 'line-width', (isFamily ? 4.5 : 2.5) + phase * (isFamily ? 3 : 1.5));
            setPaint(currentMap, layerIds.lineStringCasing, 'line-opacity', strokeOpacity);
            setPaint(currentMap, layerIds.lineStringCasing, 'line-width', (isFamily ? 10 : 7) + phase * (isFamily ? 5 : 2));
            setPaint(currentMap, layerIds.lineString, 'line-width', (isFamily ? 6 : 4) + phase * (isFamily ? 3.5 : 2));
            setPaint(currentMap, layerIds.circle, 'circle-radius', (isFamily ? 9 : 7) + phase * (isFamily ? 6 : 4));
            setPaint(currentMap, layerIds.circle, 'circle-stroke-width', (isFamily ? 3 : 2) + phase * (isFamily ? 2 : 1));

            animationFrame = requestAnimationFrame(step);
        }

        animationFrame = requestAnimationFrame(step);
    }

    return {
        start: start,
        stop: stop
    };
}
